import { LegacyStack, Text } from "@shopify/polaris";
import { CollectionPicker } from './CollectionPicker.jsx';

export function BogoConfiguration ({ form, handleChange, errors }) {
    return (
        <LegacyStack vertical>
            <LegacyStack.Item>
                {errors['configuration.collection.id'] && (
                    <div>
                        <Text  variant="bodyMd" as="span" tone="critical">{errors['configuration.collection.id']}</Text>
                    </div>
                )}
                <CollectionPicker field="collection"
                                  label="Collection"
                                  form={form}
                                  errors={errors}
                                  handleChange={handleChange}
                                  askQuantity={false} />
            </LegacyStack.Item>
        </LegacyStack>
    );
}
